var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneMemberWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 16",
    width: 11,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "one-member-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m5.1 7.4c-1.8 0-3.2-1.5-3.2-3.3c0-1.8 1.5-3.3 3.3-3.3c1.8 0 3.3 1.5 3.3 3.3c0 1.8-1.4 3.3-3.2 3.3h-0.1q0 0-0.1 0zm0-0.9c0 0 0.1 0 0.2 0c1.3-0.1 2.2-1.1 2.2-2.4c0-1.3-1-2.3-2.3-2.3c-1.3 0-2.4 1-2.4 2.3c0 1.3 1 2.3 2.3 2.4zm-4.9 5.4c0-0.9 0.5-1.8 1.4-2.4c2-1.3 5.2-1.3 7.2 0c0.9 0.6 1.4 1.5 1.4 2.4c0 0.9-0.5 1.7-1.4 2.3c-1 0.7-2.3 1-3.6 1c-1.3 0-2.6-0.3-3.6-1c-0.9-0.6-1.4-1.4-1.4-2.3zm2 1.5c1.6 1.1 4.4 1.1 6 0c0.6-0.4 1-1 1-1.5c0-0.6-0.4-1.1-1-1.5c-1.6-1.1-4.4-1.1-6 0c-0.7 0.4-1 0.9-1 1.5c0 0.5 0.3 1.1 1 1.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneMemberWhite);
export default __webpack_public_path__ + "static/media/one-member-white.6c3ab29c462e51ec369385d36ff356bc.svg";
export { ForwardRef as ReactComponent };